'use client';
import { createContext, useContext } from 'react';

const ColorSwatchesContext = createContext(void 0);
function useColorSwatchesContext() {
    return useContext(ColorSwatchesContext);
}

export { ColorSwatchesContext, useColorSwatchesContext };
